import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Avatar, Box, IconButton, Input, Paper, Tooltip } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { useAuth } from '../../hooks/use-auth';

const CommentAdd = ({ className, onSubmit, ...rest }) => {
  const { user } = useAuth();
  const [body, setBody] = useState('');

  const handleChange = (event) => {
    event.persist();
    setBody(event.target.value);
  };

  const send = () => {
    onSubmit(body);
    setBody('');
  };

  return (
    <Box
      component="form"
      onSubmit={(e) => {
        e.preventDefault();
        send();
      }}
      className={className}
      sx={{ alignItems: 'center', display: 'flex' }}
      {...rest}
    >
      <Avatar alt="Person" src={user.photoURL} />
      <Paper
        sx={{ flexGrow: 1, ml: 2, py: 0.5, px: 0.5 }}
        variant="outlined"
      >
        <Input
          disableUnderline
          fullWidth
          name="body"
          value={body}
          onChange={handleChange}
          placeholder="Leave a message"
        />
      </Paper>
      <Tooltip title="Send">
        <IconButton
          color={body.length > 0 ? 'primary' : 'default'}
          onClick={send}
          size="large"
        >
          <SendIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

CommentAdd.propTypes = {
  className: PropTypes.string,
  onSubmit: PropTypes.func,
};

export default CommentAdd;
